import { NgModule } from '@angular/core';

import { SubNavDirectivesModule } from './directives';
import { SubNavTypesModule } from './subNavTypes';
import { SubNavComponent } from './sub-nav.shared.component';

@NgModule({
    declarations: [
        SubNavComponent,
    ],
    imports: [
        SubNavTypesModule,
        SubNavDirectivesModule,
    ],
    exports: [
        SubNavComponent,
        SubNavTypesModule,
        SubNavDirectivesModule
    ],
})
export class SubNavModule { }
